<template>
  <div>
    <div class="table-wrapper">
      <div class="table">
        <div class="row header">
          <div class="cell">Delivery date</div>
          <div class="cell">Amount</div>
          <div class="cell">Meal type</div>
          <div class="cell">Created at</div>
          <div class="cell">Updated at</div>
          <div class="cell">Cancel?</div>
        </div>

        <div v-for="(item, index) in orders" :key="index" class="row">
          <div class="cell">{{ item.delivery_date.replaceAll("-", ".") }}</div>
          <div class="cell">{{ item.amount }}</div>
          <div class="cell">{{ formatMealType(item.meal_type) }}</div>
          <div class="cell">{{ formatDate(item.created_at) }}</div>
          <div class="cell">{{ formatDate(item.updated_at) }}</div>
          <div class="cell">
            <span v-if="item.confirmed"> Not possible, ordered! </span>
            <button
              v-else
              type="button"
              class="btn-action red"
              @click="cancelOrder(item)"
            >
              cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="orders.length === 0">No Data</div>

    <!--
        <button
            v-if="existBackPage"
            type="button"
            class="btn-action m-1"
            @click="backPage()"
        >
            Back page
        </button>
        <button
            v-if="existNextPage"
            type="button"
            class="btn-action m-1"
            @click="nextPage()"
        >
            Next page
        </button>
        -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import axios from "axios";
import { logDevError } from "@/utils/devLogger";
import {
  MealType,
  OrderHistoryOrder,
  OrderHistoryResponse,
  PaginationLinks,
} from "@/types/orders";
import auth from "../auth";

type OrderHistoryState = {
  orders: OrderHistoryOrder[];
  links: PaginationLinks;
  total: number;
  count: number;
};

export default defineComponent({
  name: "OrderHistory",
  data(): OrderHistoryState {
    return {
      orders: [],
      links: {},
      total: 0,
      count: 0,
    };
  },
  computed: {
    existNextPage(): boolean {
      return this.count < this.total;
    },
    existBackPage(): boolean {
      return this.count > this.orders.length;
    },
  },
  methods: {
    async cancelOrder(order: OrderHistoryOrder) {
      try {
        await axios.delete(
          `${process.env.VUE_APP_BACKEND_URL}/api/v1/orders/${order.order_id}`,
          auth.getHeader()
        );
        alert("Order canceled!");
        await this.getOrders(
          `${process.env.VUE_APP_BACKEND_URL}/api/v1/orders`
        );
      } catch (error) {
        logDevError(error);
        alert("Error");
      }
    },
    formatMealType(type: MealType | undefined) {
      if (type === "weekly") {
        return "Wochengericht";
      }
      return "Tagesgericht";
    },
    formatDate(dateStr: string) {
      const date = new Date(dateStr);
      return date.toLocaleDateString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    async getOrders(url: string) {
      try {
        const resp = await axios.get<OrderHistoryResponse>(
          url,
          auth.getHeader()
        );
        this.orders = resp.data._embedded?.items ?? [];
        this.links = resp.data.links ?? {};
        this.total = resp.data.total;
        this.count = resp.data.count;
      } catch (error) {
        logDevError(error);
      }
    },
    nextPage() {
      if (this.links.next?.href) {
        this.getOrders(this.links.next.href);
      }
    },
    backPage() {
      if (this.links.prev?.href) {
        this.getOrders(this.links.prev.href);
      }
    },
  },
  mounted() {
    if (process.env.VUE_APP_BACKEND_URL) {
      this.getOrders(`${process.env.VUE_APP_BACKEND_URL}/api/v1/orders`);
    }
  },
});
</script>
